import { render, staticRenderFns } from "./EmployerChildcareBenefitRequests.vue?vue&type=template&id=67848ae6&"
import script from "./EmployerChildcareBenefitRequests.vue?vue&type=script&lang=js&"
export * from "./EmployerChildcareBenefitRequests.vue?vue&type=script&lang=js&"
import style0 from "./EmployerChildcareBenefitRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports